import { defineStore } from 'pinia'
import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    notifications: []
  }),
  
  actions: {
    showSuccess(message, duration = 2000) {
      Toastify({
        text: message,
        duration: duration,
        gravity: "top",
        position: "center",
        style: {
          background: "#4CAF50",
        },
      }).showToast()
    },

    showError(message, duration = 2000) {
      Toastify({
        text: message,
        duration: duration,
        gravity: "top",
        position: "center",
        style: {
          background: "#f44336",
        },
      }).showToast()
    },

    showWarning(message, duration = 2000) {
      Toastify({
        text: message,
        duration: duration,
        gravity: "top",
        position: "center",
        style: {
          background: "#ff9800",
        },
      }).showToast()
    },

    showInfo(message, duration = 2000) {
      Toastify({
        text: message,
        duration: duration,
        gravity: "top",
        position: "center",
        style: {
          background: "#2196F3",
        },
      }).showToast()
    },

    showToast(message, duration = 2000, style = "#f44336", close = false, callback = null) {
      Toastify({
        text: message,
        duration: duration,
        gravity: "top",
        position: "center",
        style: {
          background: style,
        },
        close,
        onClick: callback,
      }).showToast()
    },
  }
})
